import { getError } from "@/utils/helpers";
import StatuteResultService from "@/services/statute/StatuteResultService";

export const namespaced = true;

export const state = {
  l_results: [],
  l_loading: false,
  error: null,
};

export const mutations = {
  SET_RESULT(state, l_results) {
    state.l_results = l_results;
  },
  SET_LOADING(state, loading) {
    state.l_loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getResult({ commit }, famId) {
    commit("SET_LOADING", true);

    StatuteResultService.getResultL(famId)
      .then((response) => {
        commit("SET_RESULT", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  setDefault({ commit }) {
    commit("SET_LOADING", false);
    commit("SET_ERROR", null);
    commit("SET_RESULT", []);
  },
};
export const getters = {
  l_results: (state) => {
    return state.l_results;
  },
  l_loading: (state) => {
    return state.l_loading;
  },
  error: (state) => {
    return state.error;
  },
};
